export function VesselSkeleton() {
  return (
    <div className="card-premium p-4 animate-pulse">
      <div className="flex items-start gap-3">
        <div className="w-11 h-11 rounded-xl bg-navy-700/50" />
        <div className="flex-1 space-y-2">
          <div className="h-4 bg-navy-700/50 rounded w-3/4" />
          <div className="h-3 bg-navy-700/50 rounded w-1/2" />
        </div>
      </div>
    </div>
  );
}

export function InputSkeleton() {
  return (
    <div className="space-y-4 animate-pulse">
      <div className="h-12 bg-navy-800/50 rounded-xl" />
      <div className="h-12 bg-navy-800/50 rounded-xl" />
      <div className="h-12 bg-navy-800/50 rounded-xl" />
    </div>
  );
}
